'use strict';

/**
 * @description "sticky_kit:recalc" event is not working if parent had the same height as sticky child.
 In this case child remain not sticky even after reflow.
 To fix this we initialize sticky kit only after parent node height !== sticky height
 **/

function initSticky(stickyEl) {
    const $stickyEl = $(stickyEl);

    if (stickyEl.parentNode.offsetHeight !== stickyEl.offsetHeight) {
        $stickyEl.stick_in_parent({
            offset_top: Number($stickyEl.data('offsetPx')),
            inner_scrolling: true
        });
    }
}

module.exports = {
    initStickyKit: function () {
        $('[data-sticky]').each(function () {
            const self = this;
            const $this = $(this);

            $this.css('padding-bottom', $this.data('offsetPx') + 'px');
            initSticky(self);

            const ro = new window.ResizeObserver(() => {
                initSticky(self);
            });

            ro.observe(self.parentNode);
        });
    },
    initStickyOnlyOnDesktop: function () {
        $('[data-sticky-large]').each(function () {
            const self = this;
            const $this = $(this);

            $this.css('padding-bottom', $this.data('offsetPx') + 'px');

            if (!(window.jRes.isXSmall || window.jRes.isSmall)) {
                initSticky(self);
            }

            const ro = new window.ResizeObserver(() => {
                if (!(window.jRes.isXSmall || window.jRes.isSmall)) {
                    initSticky(self);
                }
            });

            if (!(window.jRes.isXSmall || window.jRes.isSmall)) {
                ro.observe(self.parentNode);
            }

            if (window.jRes.isXSmall || window.jRes.isSmall) {
                ro.disconnect();
                $(self).trigger('sticky_kit:detach');
            }
        });
    },
    recalcOnEvents: function () {
        var _this = this;
        var $document = $(document);

        $document.on('search:showMoreUpdated', function () {
            $(document.body).trigger('sticky_kit:recalc');
        });

        $(document).on('viewportchange', function () {
            _this.initStickyOnlyOnDesktop();
        });
    }
};
